// Typed wrappers of the content language endpoints (decision D37.3; apps/api/src/routes/content-language.ts). The API
// enforces every permission (settings: organization admin; translations: project maintainer); the UI only avoids dead
// ends.
import type { OrganizationSettings, TaskTranslationRun } from "@maestros/contracts";
import { api } from "./client.ts";

export type { OrganizationSettings, TaskTranslationRun } from "@maestros/contracts";

export interface TaskTranslationResult {
  run: TaskTranslationRun | null;
  content_language: string;
  pending_tasks: number;
}

export interface TaskTranslationList {
  content_language: string;
  pending_tasks: number;
  items: TaskTranslationRun[];
}

export const getOrganizationSettings = (signal?: AbortSignal) => api<OrganizationSettings>("/organization/settings", signal ? { signal } : {});
export const updateOrganizationSettings = (body: { content_language: string }) => api<OrganizationSettings>("/organization/settings", { method: "PATCH", body });
export const listTaskTranslations = (projectId: string, signal?: AbortSignal) =>
  api<TaskTranslationList>(`/projects/${encodeURIComponent(projectId)}/task-translations`, signal ? { signal } : {});
export const requestTaskTranslation = (projectId: string, body: { allow_paid?: boolean; cost_cap_cents?: number } = {}) =>
  api<TaskTranslationResult>(`/projects/${encodeURIComponent(projectId)}/task-translations`, { method: "POST", body });
